module.exports = __webpack_public_path__ + "img/mark1.3f99f670.png";